export const ACTUALS_MISSING_DRIVER_LABEL = '(missing)'

export function driverColumnValue(item) {
  if (!item || item._overlap_group_header)
    return null
  return item.driver || ACTUALS_MISSING_DRIVER_LABEL
}

export function vehicleColumnValue(item) {
  if (!item || item._overlap_group_header)
    return null
  const value = item.vehicle || item.vehicle_type || ''
  return value || null
}

export function simpleColumnValue(field) {
  return (item) => {
    if (!item || item._overlap_group_header)
      return null
    const value = item[field]
    if (value == null || value === '')
      return null
    return String(value)
  }
}

/** Distinct column values for header filter dropdowns (excludes overlap section headers). */
export function buildDistinctColumnFilterOptions(items, valueFn, { allLabel = 'All' } = {}) {
  const values = new Set()
  for (const item of items || []) {
    if (item && item._overlap_group_header)
      continue
    const value = valueFn(item)
    if (value != null && value !== '')
      values.add(value)
  }
  const sorted = Array.from(values).sort((a, b) => String(a).localeCompare(String(b), undefined, { sensitivity: 'base' }))
  // the missing bucket is a special row, not a name, and where collation puts
  // "(missing)" depends on how the engine weighs the leading punctuation -- pin
  // it after the real names so the list is names first, special bucket last
  const missingAt = sorted.indexOf(ACTUALS_MISSING_DRIVER_LABEL)
  if (missingAt > -1) {
    sorted.splice(missingAt, 1)
    sorted.push(ACTUALS_MISSING_DRIVER_LABEL)
  }
  return [{ value: '', text: allLabel }, ...sorted.map(value => ({ value, text: value }))]
}

export function matchesActualsColumnFilter(item, selectedValue, { valueFn, overlapGroupType } = {}) {
  if (!selectedValue)
    return true
  if (item && item._overlap_group_header) {
    if (!overlapGroupType || item._overlap_group_type !== overlapGroupType)
      return false
    return item._overlap_group_line === selectedValue
  }
  return valueFn(item) === selectedValue
}

export function matchesSimpleColumnFilter(item, selectedValue, field) {
  if (!selectedValue)
    return true
  if (item && item._overlap_group_header)
    return true
  return item[field] != null && String(item[field]) === selectedValue
}
